<template>
  <div class="featured-category">
    <v-tooltip slot="append" max-width="177" top>
      <div class="label-category mt-0" slot="activator">
        <img :src="data.img" alt="">
        <span>{{ data.text }}</span>
        <strong>{{ data.percentage | formatPercentage }}</strong>
      </div>
      <span>{{ data.tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'FeaturedCategory',
  props: {
    data: {
      type: Object
    }
  }
}
</script>
